module.exports = __webpack_public_path__ + "img/左侧线条.0aff5b19.png";